import { Fragment } from "react/jsx-runtime";
import { Grid, TableRow } from "@mui/material";
import { ReportsNoItemsSection } from "../../components";
import { GenericTable } from "~/components/GenericTable/GenericTable";
import { ImpactCell, RiskFactorsCell } from "~/components/Cells";
import { ScoreRating } from "~/operations";
import { AssetCell } from "~/components/FirewatchRow/AssetCell";
import { FirstFoundCell } from "~/components/FirewatchRow/FirstFoundCell";
import React from "react";
import { ExposedAsset } from "~/pages/space/vulnerabilities/components/exposed-assets/types";
import { ReportsSectionHeading } from "~/pages/reports/components/ReportsSectionHeading";

interface CheckReportExposedAssetsProps {
  assets: Array<ExposedAsset> | undefined;
  heading: string;
}

export function CheckReportExposedAssets({
  assets,
  heading,
}: CheckReportExposedAssetsProps) {
  const noExposedAssets = assets && assets.length < 1;

  return (
    <Fragment>
      <ReportsSectionHeading heading={heading} />

      <Grid size={12} sx={{ my: 3 }}>
        {noExposedAssets ? (
          <ReportsNoItemsSection target={heading} />
        ) : (
          <GenericTable
            items={0}
            tableName={`CHECK_REPORT_AFFECTED_ASSETS`}
            validSortFields={[]}
            printView
          >
            {assets?.map((node) => {
              return (
                <TableRow key={node?.id}>
                  <ImpactCell
                    impact={node?.score || 0}
                    rating={node?.rating || ScoreRating.Critical}
                    isActive
                    hideTooltip
                  />
                  {/* Asset */}
                  <AssetCell
                    title={node?.title}
                    iconId={node?.iconId}
                    tags={node?.tags}
                  />

                  {/* Risk Factors */}
                  <RiskFactorsCell riskFactors={node?.riskFactors} printView />

                  {/* Last Updated */}
                  <FirstFoundCell discoveryTime={node?.lastUpdated} />
                </TableRow>
              );
            })}
          </GenericTable>
        )}
      </Grid>
    </Fragment>
  );
}
